import { render, staticRenderFns } from "./ListWrapper.vue?vue&type=template&id=6abdff54&scoped=true&"
import script from "./ListWrapper.vue?vue&type=script&lang=js&"
export * from "./ListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ListWrapper.vue?vue&type=style&index=0&id=6abdff54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abdff54",
  null
  
)

export default component.exports